var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkGreenBigIncomplete = function SvgCheckmarkGreenBigIncomplete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    viewBox: "0 0 184 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m83 109.622-20.02 20.016-35.308-35.307-7.228 7.227 42.535 42.534L90 117.077l-7-7.455Z",
    fill: "#18BD4E"
  })));
};
export { SvgCheckmarkGreenBigIncomplete as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTg0IiBoZWlnaHQ9IjE4NCIgdmlld0JveD0iMCAwIDE4NCAxODQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNODMuMDAwMSAxMDkuNjIyTDYyLjk3OTEgMTI5LjYzOEwyNy42NzE2IDk0LjMzMDdMMjAuNDQ0NCAxMDEuNTU4TDYyLjk3OTEgMTQ0LjA5Mkw5MC4wMDAxIDExNy4wNzdMODMuMDAwMSAxMDkuNjIyWiIgZmlsbD0iIzE4QkQ0RSIvPgo8L3N2Zz4K";